export const ANIMATE_DURATION = 2;

export const INIT_CONFIG = {
  key: 0,
  hoveredItem: null,
  selectedItems: {},
  hoveredGroup: null,
  selectedGroups: {},
};
